module.exports = __webpack_public_path__ + "img/logo-white-bg.bf08a6c5.png";